"use client"

import type { WidgetRegistrationProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { ImageUploadField } from "../../../lib/ImageUploadField"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { RenderConfig } from "./RenderConfig"

export const WidgetRegistration: ComponentConfig<WidgetRegistrationProps> = {
  label: "Tamda One | Widget Registration",
  fields: {
    title: {
      label: "Title",
      type: "text",
    },
    items: {
      label: "Items",
      type: "array",
      getItemSummary: (item: any, index = 0) => item?.title || `Item ${index + 1}`,
      arrayFields: {
        image: {
          label: "Image",
          type: "custom",
          render: (props: any) => <ImageUploadField {...props} />,
        },
        title: {
          label: "Title",
          type: "text",
        },
        description: {
          label: "Description",
          type: "textarea",
        },
        hasEmailInput: {
          label: "Has Email Input",
          type: "select",
          options: [
            { label: "Yes", value: true },
            { label: "No", value: false },
          ],
        },
        buttonType: {
          label: "Button Type",
          type: "select",
          options: [
            { label: "Link", value: "link" },
            { label: "OnClick", value: "onClick" },
          ],
        },
        buttonText: {
          label: "Button Text",
          type: "text",
        },
        buttonLink: {
          label: "Button Link",
          type: "text",
        },
        buttonOnClick: {
          label: "Button OnClick Handler",
          type: "textarea",
          description:
            "Enter JavaScript code that will be executed when button is clicked. Use 'email' variable to access the email input value.",
        },
      },
      defaultItemProps: {
        image: "",
        title: "",
        description: "",
        hasEmailInput: false,
        buttonType: "link",
        buttonText: "",
        buttonLink: "",
        buttonOnClick: "",
      },
    },
    ...(commonStylesProps as any),
  },
  defaultProps: {
    title: "",
    items: [],
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
    responsiveType: "mobileFirst",
    animation: {
      "data-aos": "",
      "data-aos-duration": "",
    },
  },
  ...RenderConfig,
}

export type { WidgetRegistrationItem, WidgetRegistrationProps } from "@/types/types"
